import { cn } from "@/lib/utils";

/**
 * The only count shown inside a tab trigger.
 * - `neutral` (default): informational totals (Active 4, Archived 2).
 * - `attention`: items waiting on the user (pending invites, requests). Hide it at 0.
 */
export function TabCount({
  value,
  tone = "neutral",
  className,
}: {
  value: number;
  tone?: "neutral" | "attention";
  className?: string;
}) {
  return (
    <span
      aria-label={`${value}`}
      className={cn(
        "num ml-1.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-xs leading-none",
        tone === "attention" ? "bg-primary text-primary-foreground" : "bg-muted-foreground/15 text-muted-foreground",
        className,
      )}
    >
      {value}
    </span>
  );
}
